module.exports = __webpack_public_path__ + "media/dorm_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/dorm_800.jpg
// module id = 26
// module chunks = 0